module.exports = "<span data-ng-message=required>* Notes are required</span> ";